import React, { useState } from 'react';
import PersonalInfoText from './PersonalInfoText';
import PersonalInfoFormText from './PersonalInfoFormText';
import PersonalInfoForm from './PersonalInfoForm';
import BottomButton from './BottomButton';
import { updateUserProfile } from '../../../../api/user/user.api';

const PersonalInfo = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [focusField, setFocusField] = useState(null);

  const handleCancel = () => {
    setIsEditing(false);
    setFocusField(null);
    window.scrollTo({ top: 0 });
  };

  const handleSave = async (payload) => {
    try {
      await updateUserProfile(payload);
      setIsEditing(false);
      setFocusField(null);
      window.scrollTo({ top: 0 });
    } catch (error) {
      console.error('Profile Save Error:', error);
    }
  };

  const handleEditField = (field) => {
    setFocusField(field);
    setIsEditing(true);
  };

  return (
    <div className='flex flex-col w-full tabletH:w-[568px] items-center gap-10 tabletH:gap-0'>
      <PersonalInfoText
        isEditing={isEditing}
        onEditClick={() => setIsEditing(true)}
      />
      {isEditing ? (
        <div className='w-full'>
          <PersonalInfoForm onSave={handleSave} focusField={focusField} />
          <BottomButton
            onCancel={handleCancel}
            onSave={() => document.dispatchEvent(new Event('saveProfile'))}
          />
        </div>
      ) : (
        <PersonalInfoFormText onEditField={handleEditField} />
      )}
    </div>
  );
};

export default PersonalInfo;
